/**
 * useIsGM Hook
 *
 * Determines if the current user is the Game Master.
 * Separated from GMTray.tsx to avoid HMR invalidation loops.
 */

import { useCampaignStore } from '../stores/campaignStore';
import { useAuthStore } from '../stores/authStore';

const GM_EMAILS = ['brottler@gmail.com'];

export function useIsGM(): boolean {
  const currentCampaign = useCampaignStore((s) => s.getCurrentCampaign());
  const user = useAuthStore((s) => s.user);

  // Check campaign role first
  if (currentCampaign?.role === 'dm') return true;

  // Fallback: email allowlist (for cases where campaign context isn't loaded yet)
  return user?.email ? GM_EMAILS.includes(user.email.toLowerCase()) : false;
}

/**
 * Non-hook variant for use inside zustand store actions / sync methods.
 * Reads the same stores via getState(). Safe to call from anywhere.
 */
export function isCurrentUserGM(): boolean {
  const currentCampaign = useCampaignStore.getState().getCurrentCampaign();
  if (currentCampaign?.role === 'dm') return true;

  const user = useAuthStore.getState().user;
  return user?.email ? GM_EMAILS.includes(user.email.toLowerCase()) : false;
}
